export default "__VITE_ASSET__514dc5d9__"